import React from "react";

/* ------------------------------------------------------------------
   Docs — Softgraph
   ------------------------------------------------------------------ */

export default function SoftgraphDocs() {
  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        {/* Table of contents */}
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#intro">Introduction</a>
          <a href="#install">Install</a>
          <a href="#usage">Usage</a>
          <a href="#models">Models</a>
          <a href="#examples">Examples</a>
        </aside>

        {/* Main content */}
        <article>
          <header className="stt-hero">
            <div className="stt-pill">softgraph • Docs</div>
            <h1 className="stt-h1">Graph ML in one call</h1>
            <p className="stt-lead">
              Quick wrappers for graph datasets and models — load, train, and
              evaluate with <em>one call</em>.
            </p>
          </header>

          <section id="intro" className="stt-section">
            <h2 className="stt-h2">What is softgraph?</h2>
            <p className="stt-p">
              A teaching-first graph machine learning library. It removes setup
              friction so students can focus on <strong>concepts</strong>:
              temporal graphs, embeddings, and node classification.
            </p>
          </section>

          <section id="install" className="stt-section">
            <h2 className="stt-h2">Installation</h2>
            <div className="stt-code">
              <pre className="stt-pre">pip install softgraph</pre>
            </div>
          </section>

          <section id="usage" className="stt-section">
            <h2 className="stt-h2">Basic Usage</h2>
            <div className="stt-code">
              <pre className="stt-pre">{`from softgraph import softgraph

results = softgraph(
    task="node_classification",
    model="gcn",
    dataset="cora",
    plot=True
)

print(results)
# {'accuracy': 0.82, 'f1_macro': 0.79}`}</pre>
            </div>
          </section>

          <section id="models" className="stt-section">
            <h2 className="stt-h2">Available Models</h2>
            <ul className="stt-list">
              <li><strong>GCN</strong> — Graph Convolutional Network</li>
              <li><strong>GraphSAGE</strong> — inductive representation</li>
              <li><strong>TGAT</strong> — Temporal GNN</li>
              <li><strong>MLP</strong> — baseline</li>
            </ul>
          </section>

          <section id="examples" className="stt-section">
            <h2 className="stt-h2">Examples</h2>
            <p className="stt-p">
              Explore live notebooks and code snippets in the{" "}
              <a href="/examples/softgraph" className="stt-link">examples</a>{" "}
              section.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}
